export default __webpack_public_path__ + "static/media/weather.57bb689b.jpg";